<template> 
  <course-form :is-edit='true' :cno='cno'></course-form>
</template>
<script>
import CourseForm from './courseForm'
export default {
  name: 'updateCourse',
  components: { CourseForm },
  data() {
    return {
      cno: ''
    }
  },
  created() {
    this.cno = this.$route.query.cno
  },
}
</script>
<style>
</style>


